(function($) {
    $('body').on('click', '[data-dropform-trigger]', function(e) {
        e.preventDefault();
        meshStartLayoutRefreshInterval();
        $('.dropform').slideToggle(function() {
            meshStopLayoutRefreshInterval();
        });
    });
})(jQuery);